// src/components/FileManager/FileManagerModal.jsx
import React from "react";
import { X } from "lucide-react";
import ModalBackdrop from "components/ModalBackdrop";
import FileManagerPanel from "./FileManagerPanel";

export default function FileManagerModal({
  entityName = "Record",
  adapter,
  view,
  onClose,
  onSelect,
}) {
  if (!adapter) {
    throw new Error("FileManagerModal requires an `adapter` prop.");
  }
  if (!view) {
    throw new Error("FileManagerModal requires a `view` prop.");
  }

  return (
    <ModalBackdrop onClose={onClose}>
      <div
        className="relative mx-auto h-full max-h-[calc(100vh-2rem)] w-[800px] max-w-full bg-[hsl(var(--background))] text-app rounded-xl shadow-xl border border-border flex flex-col overflow-hidden"
        role="dialog"
        aria-modal="true"
        aria-label={`${entityName} file manager`}
      >
        <button
          type="button"
          onClick={onClose}
          className={[
            "absolute right-3 top-3 z-10",
            "inline-flex items-center justify-center",
            "h-8 w-8 rounded-md",
            "text-muted hover:text-app",
            "hover:bg-[hsl(var(--muted))]/50",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:ring-offset-2",
            "focus-visible:ring-offset-[hsl(var(--background))]",
            "transition-colors",
          ].join(" ")}
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="flex-1 min-h-0 overflow-hidden">
          <FileManagerPanel
            entityName={entityName}
            adapter={adapter}
            view={view}
            onSelect={onSelect}
            onClose={onClose}
            framed={false}
            showToolbar={true}
            showFooter={true}
            className="h-full"
            maxHeightClassName=""
          />
        </div>
      </div>
    </ModalBackdrop>
  );
}
